export function open(url: string) {
    window.open(url, "_blank")
}